import { Box, Typography } from "@material-ui/core";
import {
  ActionButton,
  ActionLink,
  CloseButtonIcon,
  Icon,
  IconName,
} from "halifax";
import React, { useState } from "react";
import clsx from "clsx";
import "./styles.scss";
import {
  ENTERED_USEFULNESS_SCALE,
  PackageEntryProperties,
  SUBMIT_FEEDBACK,
} from "redmond";
import {
  ADD_CARS,
  PackagesSmokeTestPropVariantType,
  PARTIAL_STAYS,
} from "../../../../../context/experiments";
import {
  getFeatureSmokeTestTitle,
  HOW_HELPFUL,
  NOT_USEFUL,
  TEST_SUBTITLE,
  VERY_USEFUL,
} from "../textConstants";
import { trackEvent } from "../../../../../api/v0/trackEvent";

interface IFeatureSmokeTestModalContentProps {
  onClose: () => void;
  isMobile?: boolean;
  variant: PackagesSmokeTestPropVariantType;
  entryProperties: PackageEntryProperties;
}
export const FeatureSmokeTestModalContent = ({
  onClose,
  isMobile = false,
  variant,
  entryProperties,
}: IFeatureSmokeTestModalContentProps) => {
  const [rating, setRating] = useState(0);

  return (
    <Box
      className={clsx("feature-smoke-test-modal-content", {
        mobile: isMobile,
      })}
    >
      <Box className="top-content-container">
        <ActionLink
          className="feature-smoke-test-modal-close-button"
          onClick={onClose}
          content={<CloseButtonIcon className="close-button-icon" />}
          label="Close"
          showTappableArea
        />

        <Icon name={IconName.FeatureSmokeTestLightBulb} />
        <Typography variant="h2" className="title">
          {getFeatureSmokeTestTitle(variant)}
        </Typography>
        <Typography variant="body2" className="subtitle">
          {TEST_SUBTITLE}
        </Typography>
      </Box>
      <Box className="bottom-content-container">
        <Typography className="text">{HOW_HELPFUL}</Typography>
        <Box className="rating-container">
          <Box className="rating">
            {[...Array(5)].map((_currRating, index) => (
              <>
                <label
                  htmlFor={`rating-${index + 1}`}
                  className={clsx("rating-label", {
                    filled: rating >= index + 1,
                  })}
                >
                  {index + 1}
                </label>

                <input
                  type="radio"
                  value={index + 1}
                  onClick={() => {
                    setRating(index + 1);
                    trackEvent({
                      eventName: ENTERED_USEFULNESS_SCALE,
                      properties: {
                        usefulness: index + 1,
                      },
                    });
                  }}
                  id={`rating-${index + 1}`}
                  name={`rating-${index + 1}`}
                  checked={index + 1 === rating}
                />
              </>
            ))}
          </Box>

          <Box className="rating-usefulness-labels">
            <Typography className="label" variant="body2">
              {NOT_USEFUL}
            </Typography>
            <Typography className="label" variant="body2">
              {VERY_USEFUL}
            </Typography>
          </Box>
        </Box>
        <ActionButton
          key="submit-feedback"
          disabled={!rating}
          message="Submit feedback"
          onClick={() => {
            onClose();
            trackEvent({
              eventName: SUBMIT_FEEDBACK,
              properties: {
                usefulness: rating,
                test_name:
                  variant === PARTIAL_STAYS
                    ? "package_partial_stay"
                    : variant === ADD_CARS
                    ? "package_add_car"
                    : variant,
                ...entryProperties,
              },
            });
          }}
          className="submit-feedback-cta b2b"
        />
      </Box>
    </Box>
  );
};
